import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-1/3">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-semibold text-primary-600 tracking-wide whitespace-nowrap cursor-pointer">
                三上悠亞
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-sm">
              三上悠亞官方粉絲落地頁，匯集最新作品、寫真、個人資料及粉絲資訊，帶你全面了解三上悠亞的演藝世界。
            </p>
          </div>

          <div className="flex flex-wrap gap-8 lg:gap-16">
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">快速連結</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">首頁</Link></li>
                <li><Link to="/category" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">分類瀏覽</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">關於我們</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">熱門分類</h4>
              <ul className="space-y-2">
                <li><Link to="/category?tab=works" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">作品</Link></li>
                <li><Link to="/category?tab=photobooks" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">寫真</Link></li>
                <li><Link to="/category?tab=news" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer">最新消息</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-3">關注我們</h4>
              <div className="flex items-center gap-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors duration-200 cursor-pointer" aria-label="Instagram">
                  <i className="ri-instagram-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors duration-200 cursor-pointer" aria-label="Twitter">
                  <i className="ri-twitter-x-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors duration-200 cursor-pointer" aria-label="YouTube">
                  <i className="ri-youtube-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 三上悠亞粉絲頁. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200">隱私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors duration-200">使用條款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}